import './App.scss';
import Header from '../Tools/Header/Header';
import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import Notification from '../Tools/Notification/Notification';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Main from './Main';
import CompaniesData from './Companies';
import axios from 'axios';

function App() {
  const [UserSession, setUserSession] = useState({})
  const [UpdateAppSub, setUpdateAppSub] = useState(true)
  const [ShowAllCompanies, setShowAllCompanies] = useState(false);
  const [CitiesData, setCitiesData] = useState({});
  const [UpdateApp, setUpdateApp] = useState(true)
  const [ZipCode, setZipCode] = useState(localStorage.getItem("ZipCode"));
  const [showMenu, setShowMenu] = useState(false)
  const [showNotification, showsetNotification] = useState(false)
  const [showNotificationType, showsetNotificationType] = useState("")
  const navigate = useNavigate()
  const location = useLocation()
  const url = new URL(window.location.href);


  const [ProjectList, setProjectList] = useState(localStorage.getItem("Project") && JSON.parse(localStorage.getItem("Project")).length ? JSON.parse(localStorage.getItem("Project")) : [])
  const [WebSitePages, setWebSitePages] = useState([
    {
      Name: "Home Page",
      Path: "/"
    },
    {
      Name: "Contact",
      Path: "/contact"
    },
    {
      Name: "About",
      Path: "/about"
    },
    {
      Name: "Blog",
      Path: "/blog"
    },
    {
      Name: "Privacy Policy",
      Path: "/privacy_policy"
    },
    {
      Name: "Terms Conditions",
      Path: "/terms_conditions"
    },
    {
      Name: "Site Map",
      Path: "/sitemap"
    },
  ]);

  const [ServicesData, setServicesData] = useState([
    {
      category: "Chimney Sweep",
      sub_services: [
        "Chimney Cleaning",
        "Chimney Inspection",
        "Chimney Repair",
        "Chimney Cap Replacement",
        "Chimney Liner Installation",
        "Fireplace Cleaning",
        "Fireplace Inspection",
        "Smoke Chamber Repair",
        "Creosote Removal",
        "Masonry Chimney Repair",
        "Chimney Waterproofing",
        "Chimney Animal Removal",
        "Chimney Leak Detection",
        "Chimney Crown Repair",
        "Chimney Flashing Repair",
        "Chimney Repointing",
        "Fireplace Damper Repair",
        "Chimney Odor Removal",
        "Chimney Draft Issue Fixing",
        "Chimney Flue Cleaning"
      ]
    },
    {
      category: "Garage Door",
      sub_services: [
        "Garage Door Installation",
        "Garage Door Repair",
        "Garage Door Spring Replacement",
        "Garage Door Opener Repair",
        "Garage Door Opener Installation",
        "Garage Door Off Track Repair",
        "Garage Door Cable Repair",
        "Garage Door Panel Replacement",
        "Garage Door Remote Programming",
        "Garage Door Sensor Alignment",
        "Garage Door Maintenance",
        "Garage Door Tune-Up",
        "Garage Door Weather Stripping",
        "Garage Door Noise Reduction",
        "Garage Door Roller Replacement",
        "Garage Door Keypad Installation",
        "Garage Door Balance Adjustment",
        "Garage Door Safety Inspection"
      ]
    },
    {
      category: "Locksmith",
      sub_services: [
        "Emergency Locksmith",
        "Lock Repair",
        "Rekeying Services",
        "Key Duplication",
        "Smart Lock Installation",
        "Commercial Locksmith Services",
        "Residential Locksmith Services",
        "Car Lockout Assistance",
        "Mailbox Lock Replacement",
        "High-Security Lock Installation",
        "Broken Key Extraction",
        "Safe Unlocking Services",
        "Access Control System Setup",
        "Master Key System Installation",
        "Keyless Entry System Installation",
        "Digital Lock Configuration",
        "Lock Replacement",
        "Cabinet Lock Repair",
        "Sliding Door Lock Fix"
      ]
    },
    {
      category: "Roofing",
      sub_services: [
        "Roof Repair",
        "Roof Replacement",
        "Roof Inspection",
        "Leaky Roof Repair",
        "Shingle Roofing",
        "Tile Roofing",
        "Flat Roofing",
        "Gutter Installation",
        "Roof Ventilation Installation",
        "Roof Flashing Repair",
        "Skylight Leak Repair",
        "Roof Storm Damage Repair",
        "Roof Moss Removal",
        "Roof Ice Dam Removal",
        "Emergency Roof Tarping",
        "Roof Deck Replacement",
        "Soffit and Fascia Repair",
        "Solar Panel Roof Prep",
        "Roof Sealant Application",
        "Metal Roof Installation"
      ]
    },
    {
      category: "Air Duct",
      sub_services: [
        "Air Duct Cleaning",
        "Air Duct Inspection",
        "Air Duct Repair",
        "Air Duct Replacement",
        "Duct Sanitization",
        "Duct Leak Sealing",
        "HVAC Duct Cleaning",
        "Vent Cover Replacement",
        "Return Duct Cleaning",
        "Flexible Duct Replacement",
        "Air Duct Odor Removal",
        "Airflow Testing",
        "Air Duct Balancing",
        "Mold in Duct Treatment",
        "Zoned Duct System Service"
      ]
    },
    {
      category: "Dryer Vent",
      sub_services: [
        "Dryer Vent Cleaning",
        "Dryer Vent Inspection",
        "Dryer Vent Repair",
        "Dryer Vent Rerouting",
        "Dryer Vent Installation",
        "Dryer Vent Clog Removal",
        "Dryer Vent Booster Fan Installation",
        "Roof Dryer Vent Exit Service",
        "Dryer Hose Replacement",
        "Lint Trap Cleaning"
      ]
    },
    {
      category: "HVAC",
      sub_services: [
        "AC Installation",
        "AC Repair",
        "Furnace Repair",
        "Furnace Installation",
        "HVAC System Maintenance",
        "Thermostat Installation",
        "Mini Split Installation",
        "HVAC Troubleshooting",
        "HVAC Tune-Up",
        "Ductless AC Installation",
        "Smart Thermostat Setup",
        "Blower Motor Replacement",
        "Evaporator Coil Cleaning",
        "Heat Pump Installation",
        "Emergency HVAC Repair",
        "Filter Replacement Service",
        "Condensate Drain Cleaning"
      ]
    },
    {
      "category": "Cleaning",
      "sub_services": [
        "Asbestos Removal",
        "Asbestos Removal Contractors",
        "Bee Removal",
        "Blind Cleaning",
        "Carpet Cleaning",
        "Carpet Removal",
        "Central Vacuum Cleaning",
        "Cleaning",
        "Cleaning Crews",
        "Commercial Cleaning Services",
        "Commercial Floor Cleaning",
        "Commercial Snow Removal",
        "Concrete Removal",
        "Couch Cleaning",
        "Couch Removal",
        "Deck Cleaning Services",
        "Dirt Hauling",
        "Drain Cleaning",
        "Drapery Cleaning"
      ]
    },
    {
      "category": "Remodeling & Construction",
      "sub_services": [
        "Barn Builders",
        "Barndominium Builders",
        "Basement Pro",
        "Basement Finishing",
        "Basement Leak Repair",
        "Basement Waterproofing",
        "Bathroom Design Pro",
        "Bathroom Fan Installation",
        "Bathroom Remodeling",
        "Bathroom Repair Services",
        "Bathroom Tile Contractors",
        "Bathroom Tile Repair",
        "Bathroom Vanity Installation",
        "Builders",
        "Construction Management",
        "Custom Builders",
        "Custom Furniture Builders",
        "Dock Builders"
      ]
    },
    {
      "category": "Dryer Vent & Appliances",
      "sub_services": [
        "Appliance Installers",
        "Appliance Removal",
        "Appliance Repair",
        "Appliance Repair Pro",
        "Appliance Sales",
        "Bosch Appliance Repair",
        "Dishwasher Installation",
        "Dishwasher Repair",
        "Dryer Repair",
        "Dryer Vent Cleaning"
      ]
    },
    {
      "category": "Flooring",
      "sub_services": [
        "Carpet Dyeing",
        "Carpet Installation",
        "Carpet Layers",
        "Carpet Repair Pro",
        "Carpet Shampoo Services",
        "Carpet Steam Cleaners",
        "Carpet Stretching Services",
        "Ceiling Tile Installation",
        "Ceramic Tile",
        "Ceramic Tile Pro",
        "Ceramic Tile Repair",
        "Commercial Carpet Cleaners",
        "Concrete Floor Staining"
      ]
    },
    {
      "category": "HVAC",
      "sub_services": [
        "Air Conditioning Installation",
        "Air Conditioning Repair"
      ]
    },
    {
      "category": "Plumbing",
      "sub_services": [
        "Affordable Plumbing",
        "Commercial Plumber"
      ]
    },
    {
      "category": "Painting",
      "sub_services": [
        "Cabinet Painting",
        "Ceiling Painters",
        "Commercial Painting",
        "Deck Painters"
      ]
    },
    {
      "category": "Windows & Doors",
      "sub_services": [
        "Commercial Door Repair",
        "Commercial Window Pro",
        "Commercial Window Tinting",
        "Door Installation",
        "Door Lock Repair Services",
        "Door Refinishing",
        "Door Repair"
      ]
    },
    {
      "category": "Concrete & Masonry",
      "sub_services": [
        "Brick Paver Pro",
        "Concrete Contractors",
        "Concrete Cutting",
        "Concrete Delivery Pro",
        "Concrete Demolition",
        "Concrete Driveway Pro",
        "Concrete Finishing",
        "Concrete Flooring",
        "Concrete Foundation Pro",
        "Concrete Leveling",
        "Concrete Masons",
        "Concrete Mudjacking",
        "Concrete Patio Contractors",
        "Concrete Repair",
        "Concrete Resurfacing",
        "Concrete Steps Repair",
        "Concrete Walls",
        "Decorative Concrete"
      ]
    },
    {
      "category": "Fencing & Gates",
      "sub_services": [
        "Aluminum Fence Pro",
        "Chain Link Fence Pro",
        "Chain Link Fence Repair",
        "Dog Fence Pro"
      ]
    },
    {
      "category": "Insulation",
      "sub_services": [
        "Attic Fan Installation",
        "Attic Fan Repair",
        "Attic Insulation Pro",
        "Attic Ladder Installation",
        "Attic Ventilation Contractors",
        "Blown-In Insulation",
        "Commercial Insulation",
        "Drywall & Insulation Contractors"
      ]
    },
    {
      "category": "Pest Control",
      "sub_services": [
        "Animal Control",
        "Bat Control",
        "Bed Bug Control",
        "Bird Control",
        "Bug Control",
        "Cockroach Control"
      ]
    },
    {
      "category": "Roofing",
      "sub_services": [
        "Business Roof Repair",
        "Copper Gutters"
      ]
    },

    {
      "category": "Security",
      "sub_services": [
        "Alarm Pro",
        "Doorbell Installation"
      ]
    },
    {
      "category": "Pool & Spa",
      "sub_services": [
        "Above Ground Pool Contractors",
        "Above Ground Pool Repair"
      ]
    },
    {
      "category": "Real Estate",
      "sub_services": [
        "Black Mold Inspection"
      ]
    },
    {
      "category": "Other / Uncategorized",
      "sub_services": [
        "Affordable Roofing",
        "Animal Fencing",
        "Ant Exterminators",
        "Antique Lamp Repair",
        "Antique Restoration",
        "Apartment Cleaners",
        "Appliances",
        "Appraisals - Antiques/Jewelry/Items",
        "Aquarium Services",
        "Arborists",
        "Architects",
        "Artificial Grass Pro",
        "Asbestos Testers",
        "Asphalt Contractors",
        "Asphalt Driveway Contractors",
        "Asphalt Patching",
        "Asphalt Repair Pro",
        "Asphalt Resurfacing Pro",
        "Asphalt Sealing",
        "Awning Pro",
        "Awning Repair",
        "Awnings",
        "Backsplash Installation",
        "Backyard Design Pro",
        "Backyard Landscapers",
        "Balcony Contractors",
        "Barn Repair",
        "Baseboard Installation",
        "Basketball Goals",
        "Bathtub Installation",
        "Bathtub Refinishing",
        "Bathtub Repair Pro",
        "Bathtub Replacement",
        "Biohazard Remediation",
        "Blacktop Pro",
        "Blind Installation",
        "Blind Repair",
        "Block Wall Pro",
        "Boat Dock Repair",
        "Boiler Installation",
        "Boiler Repair",
        "Brush Chipping Services",
        "Buffing and Polishing",
        "Building Contractors",
        "CAD Drafting Services",
        "Cabinet Installers",
        "Cabinet Makers",
        "Cabinet Refacing",
        "Cabinet Refacing and Refinishing",
        "Cabinet Refinishers",
        "Cabinet Repair",
        "Carpentry",
        "Carport Installation",
        "Carport Repair",
        "Caulking Services",
        "Ceiling Pro",
        "Ceiling Fan Pro",
        "Ceiling Fan Repair",
        "Ceiling Fans",
        "Ceiling Repair Pro",
        "Cement Pro",
        "Central Vacuum Installation",
        "Central Vacuum Repair",
        "Chair Lift Pro",
        "Chandelier Installation",
        "Childproofing",
        "Christmas Lights Installers",
        "Closet Design Pro",
        "Closet Makers",
        "Closets",
        "Commercial A/C Repair",
        "Commercial Architects",
        "Commercial Carpeting",
        "Commercial Electricians",
        "Commercial Landscaping",
        "Commercial Locksmiths",
        "Commercial Pavers",
        "Commercial Roofing",
        "Computer Repair Services",
        "Corian Countertops",
        "Couch Repair Services",
        "Countertop Installation",
        "Countertop Repair",
        "Countertop Resurfacing Pro",
        "Crawl Space Encapsulation",
        "Crown Molding Pro",
        "Curtain & Drapery Installation",
        "Curtain & Drapery Repair",
        "Custom Woodworking",
        "Deck Pro",
        "Deck Maintenance",
        "Deck Refinishing Services",
        "Deck Repair Pro",
        "Deck Staining Pro",
        "Decks and Porches",
        "Dehumidifier & Humidifier Repair",
        "Demolition Services",
        "Dock Building & Repair",
        "Doors",
        "Drain Contractors",
        "Drain Pipe Installation",
        "Drapery Alterations",
        "Driveway Gates",
        "Driveway Pavers",
        "Driveway Paving Pro",
        "Driveway Repair",
        "Driveway Sealing",
        "Dryvit Contractors",
        "Drywall",
        "Drywall Installers",
        "Drywall Repair",
        "Duct Installers",
        "Dumpster Rental"
      ]
    }
  ])

  const [Companies, setCompanies] = useState(CompaniesData)

  // Update CategoryInfo reviews when CitiesData changes
  useEffect(() => {
    setCategoryInfo(prev =>
      prev.map(cat => {
        if (cat.faq && cat.faq.data && cat.faq.data.title && Array.isArray(cat.faq.data.rows) && cat.faq.data.rows.length > 0) {
          return {
            ...cat,
            faq: {
              ...cat.faq,
              data: {
                ...cat.faq.data,
                title: `Top 5 ${cat.Category} Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
                rows: cat.faq.data.rows.map((row, idx) =>
                  idx === 0
                    ? {
                      ...row,
                      content: `These contractors were handpicked based on customer reviews, service quality, reliability, and response times in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}.`
                    }
                    : row
                )
              }
            }
          };
        }
        return cat;
      })
    );
  }, [CitiesData]);

  const [CategoryInfo, setCategoryInfo] = useState([
    // Air Duct Category Info
    {
      "Category": "Air Duct",
      "UrlCategory": "Air-Duct",
      "Image": require(`../Images/airductbanner.jpg`),
      "Reviews": [{
        'name': 'Jessica S.',
        'date': 'March 03, 2025',
        'review': `HandyBy made it so easy to find a reliable air duct cleaner ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. The pro they matched me with was punctual, professional, and explained every step. My home's air quality is noticeably better. Highly recommend!`
      },
      {
        'name': 'Michael S.',
        'date': 'March 15, 2025',
        'review': `Thanks to HandyBy, I got connected with a local air duct pro ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who was upfront and honest. They cleaned my ducts thoroughly and even checked for leaks at no extra cost.`
      },
      {
        'name': 'Robert T.',
        'date': 'February 10, 2025',
        'review': 'Finding the right pro was effortless with HandyBy. The technician they sent did a fantastic job cleaning my air ducts and was very respectful of my home.'
      },
      {
        'name': 'Michael T.',
        'date': 'April 23, 2025',
        'review': `HandyBy matched me with an air duct specialist ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who identified a mold issue I wasn’t aware of. They handled it professionally and gave great tips for prevention.`
      },
      {
        'name': 'Steven T.',
        'date': 'March 08, 2025',
        'review': 'I used HandyBy to find a pro for air duct cleaning. The service was prompt, affordable, and my allergies have improved since. Highly recommend their pros.'
      },
      {
        'name': 'James S.',
        'date': 'April 08, 2025',
        'review': 'The HandyBy platform connected me with a trustworthy air duct pro who explained everything clearly and didn’t try to upsell me. Great experience!'
      },
      {
        'name': 'Chloe P.',
        'date': 'March 25, 2025',
        'review': 'I had no idea who to call for air duct cleaning until I found HandyBy. The pro they recommended was thorough, honest, and left my house spotless.'
      },
      {
        'name': 'Chloe J.',
        'date': 'March 28, 2025',
        'review': 'HandyBy helped me get in touch with a local pro who cleaned my air ducts and fixed a minor leak I didn’t know about. Professional, affordable, and fast.'
      },
      {
        'name': 'John B.',
        'date': 'March 07, 2025',
        'review': 'I used HandyBy to request an air duct service and was impressed with how quickly they matched me with a pro. The work was excellent, and the price was fair.'
      },
      {
        'name': 'Jessica J.',
        'date': 'March 03, 2025',
        'review': 'HandyBy took the guesswork out of finding a good air duct cleaner. The pro was on time, friendly, and very knowledgeable. Couldn’t be happier.'
      },
      {
        'name': 'Emily D.',
        'date': 'April 15, 2025',
        'review': 'After struggling to find a reliable service, HandyBy matched me with a true professional. My air ducts were cleaned thoroughly, and the pro even gave maintenance tips.'
      },
      {
        'name': 'Daniel J.',
        'date': 'May 11, 2025',
        'review': 'Thanks to HandyBy, I didn’t have to waste time searching. The air duct pro they sent was efficient and explained everything. Highly recommend.'
      },
      {
        'name': 'Jessica P.',
        'date': 'May 05, 2025',
        'review': 'HandyBy made it simple to get air duct cleaning done right. The technician was polite, skilled, and completed the job quickly.'
      },
      {
        'name': 'Emily M.',
        'date': 'March 19, 2025',
        'review': 'I’m so glad I used HandyBy. They connected me with a local air duct expert who was honest, reasonably priced, and did a great job.'
      },
      {
        'name': 'Amanda R.',
        'date': 'March 25, 2025',
        'review': 'HandyBy matched me with a pro who was upfront about the work needed and didn’t try to upsell unnecessary services. Very satisfied.'
      },
      {
        'name': 'Amanda S.',
        'date': 'March 26, 2025',
        'review': 'The air duct pro HandyBy connected me with was fantastic. They were prompt, transparent with pricing, and left my ducts spotless.'
      },
      {
        'name': 'Amanda D.',
        'date': 'April 27, 2025',
        'review': 'Using HandyBy was a breeze. The pro they matched me with cleaned my ducts and even checked my dryer vent for safety. Great service!'
      },
      {
        'name': 'Daniel B.',
        'date': 'February 16, 2025',
        'review': 'HandyBy helped me find an air duct technician who was both professional and friendly. They walked me through the whole process and delivered great results.'
      },
      {
        'name': 'Ashley R.',
        'date': 'March 09, 2025',
        'review': 'I trusted HandyBy to find a reliable air duct pro, and they delivered. The pro was thorough, polite, and did the job right the first time.'
      },
      {
        'name': 'Robert D.',
        'date': 'March 25, 2025',
        'review': 'I wasn’t sure where to start with air duct cleaning, but HandyBy made it easy. The pro they sent was excellent, transparent, and cleaned up after the job.'
      }],
      "Projects": [
        {
          "Title": "Air Duct Leak Detection",
          "Description": "Another Successful HandyBy Match—Sealing Leaks And Restoring Airflow.",
          "Images": require(`../Images/AirDuctProject1.jpeg`)
        },
        {
          "Title": "Air Duct Cleaning & Sanitizing",
          "Description": "HandyBy Matched The Customer With A Trusted Expert Who Handled The Job Efficiently.",
          "Images": require(`../Images/AirDuctProject7.jpeg`)
        },
        {
          "Title": "New Air Duct System Installed",
          "Description": " Our Verified Pro Installed A High-Quality Duct System For Improved Airflow.",
          "Images": require(`../Images/AirDuctProject3.jpeg`)
        },
        {
          "Title": "Residential Air Duct Cleaning",
          "Description": "Our Pro Removed Dust, Debris, And Improved Indoor Air Quality For This Homeowner.",
          "Images": require(`../Images/AirDuctProject4.jpeg`)
        },
        {
          "Title": "Air Duct Leak Patched",
          "Description": "HandyBy Matched The Homeowner With A Local Pro Who Sealed Leaks And Restored Airflow.",
          "Images": require(`../Images/AirDuctProject2.jpeg`)
        },
        {
          "Title": "Cleaning For Allergy Relief",
          "Description": "A HandyBy Pro Cleaned The Ducts To Reduce Allergens And Improve Airflow.",
          "Images": require(`../Images/AirDuctProject5.jpeg`)
        },
        {
          "Title": "Air Duct Deep Cleaning",
          "Description": "HandyBy Connected The Homeowner With A Skilled Pro For Safe, Effective Cleaning.",
          "Images": require(`../Images/AirDuctProject6.jpeg`)
        }
      ],
      "Services": [
        {
          "Title": "Air Duct Cleaning",
          "Description": "Thorough cleaning of air ducts to improve indoor air quality.",
          "Images": require(`../Images/airductbanner.jpg`)
        },
        {
          "Title": "Air Duct Inspection",
          "Description": "Comprehensive inspection to identify leaks, blockages, and damage.",
          "Images": require(`../Images/1-airduct.jpg`)
        },
        {
          "Title": "Air Duct Repair",
          "Description": "Expert repair services for damaged or leaking air ducts.",
          "Images": require(`../Images/bho-Chimney11Cairdductrepair.webp`)
        },
        {
          "Title": "Air Duct Installation",
          "Description": "Professional installation of new air duct systems for improved airflow.",
          "Images": require(`../Images/ducts.jpg`)
        },
        {
          "Title": "Air Duct Maintenance",
          "Description": "Regular maintenance services to keep air ducts clean and efficient.",
          "Images": require(`../Images/bho-airduuctcleaning.webp`)
        },
        {
          "Title": "Air Duct Sanitizing",
          "Description": "Sanitization services to eliminate bacteria and allergens in air ducts.",
          "Images": require(`../Images/bho-airductservice.webp`)
        },
        {
          "Title": "Ducts Replacement",
          "Description": "Replacement of old or damaged air ducts to improve system efficiency.",
          "Images": require(`../Images/airductuv.jpg`)
        },
        {
          "Title": "Dryer Vent Cleaning",
          "Description": "Cleaning of dryer vents to prevent fire hazards and improve efficiency.",
          "Images": require(`../Images/dryerventcleaning.jpg`)
        },
        {
          "Title": "Air Duct Sealing",
          "Description": "Sealing air ducts to prevent leaks and improve energy efficiency.",
          "Images": require(`../Images/PhotoImg5.png`)
        }
      ],
      "ServicesByCategory": [
        {
          "category": "Air Duct Cleaning",
          "services": [
            "indoor air duct cleaning",
            "air conditioner duct cleaning service",
            "duct cleaning",
            "commercial duct cleaning",
            "quality air duct cleaning",
            "vent cleaners for home",
            "duct cleaning services",
            "air duct cleaning experts",
            "air conditioning and heating duct cleaning",
            "clean duct vents",
            "central air cleaning service",
            "home ac cleaning service",
            "ac dust cleaning"
          ]
        },
        {
          "category": "HVAC & Furnace Cleaning",
          "services": [
            "furnace cleaning service",
            "home hvac duct cleaning",
            "professional hvac cleaning",
            "furnace cleaning and service",
            "hvac air vent cleaning",
            "furnace duct cleaning companies",
            "furnace cleaning companies",
            "home hvac cleaning",
            "hvac air cleaning"
          ]
        },
        {
          "category": "Dryer Vent Cleaning & Repair",
          "services": [
            "ac and dryer vent cleaning",
            "dryer vent hose repair",
            "dryer vent repair",
            "dryer duct repair",
            "dryer vent repair service",
            "dryer vent installation service",
            "professional dryer vent installation",
            "dryer repair and vent cleaning",
            "dryer vent repair company",
            "dryer vent installation"
          ]
        },
        {
          "category": "Duct & Vent Repair Services",
          "services": [
            "air duct repair",
            "ac duct repair",
            "duct repair",
            "duct and vent repair"
          ]
        },
        {
          "category": "Duct Sanitizing & Disinfection",
          "services": [
            "air duct disinfection",
            "ac duct cleaning and disinfection"
          ]
        },
        {
          "category": "Inspection & Estimate Services",
          "services": [
            "air duct inspection and cleaning",
            "air duct cleaning estimate",
            "duct cleaning estimates",
            "ac duct inspection",
            "air duct cleaning free estimate"
          ]
        }
      ],
      "faq": {
        data: {
          title: `Top 5 Air Duct Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            {
              title: "Why are these the Top 5 Air Duct Pros?",
              content: `These contractors were handpicked based on customer reviews, service quality, reliability, and response times in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}.`
            },
            {
              title: "Are these pros licensed and insured?",
              content: "Yes. All listed air duct professionals are fully licensed, insured, and verified to ensure safe and dependable service."
            },
            {
              title: "What services do these pros offer?",
              content: "They provide air duct cleaning, inspections, repairs, sanitizing, and dryer vent cleaning for both residential and commercial properties."
            },
            {
              title: "How quickly can they schedule a service?",
              content: "Most of the pros offer same-day or next-day service depending on availability and location."
            },
            {
              title: "Is there a cost to choose from the Top 5?",
              content: "No. Viewing and selecting a contractor from the list is completely free and there’s no obligation to hire."
            },
            {
              title: "Can I request quotes from all three?",
              content: "Absolutely. You’re free to contact all three pros to compare pricing, timelines, and available services."
            }
          ]
        },
        styles: {
          bgColor: 'white',
          titleTextColor: '#282827',
          titleTextSize: '18px',
          rowTitleColor: '#282827',
          rowTitleTextSize: '18px',
          rowContentColor: '#242424',
          rowContentTextSize: '16px',
          // rowContentTextWeight: '600',
          rowContentPaddingTop: '10px',
          rowContentPaddingBottom: '0px',
          rowContentPaddingLeft: '5px',
          rowContentPaddingRight: '5px',
          arrowColor: "#282827",
          //transitionDuration: "1s",
          // timingFunc: "ease"
        },
        config: {
          // animate: true,
          // arrowIcon: "V",
          // tabFocus: true
          openOnload: 0,
        },
      }
    },
    // Dryer Category Info
    {
      "Category": "Dryer Vent",
      "UrlCategory": "Dryer-Vent",
      "Image": require(`../Images/1-dryervent.jpg`),
      "Reviews": [{
        'name': 'Jessica S.',
        'date': 'March 03, 2025',
        'review': `HandyBy made it so easy to find a reliable dryer vent cleaner ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. The pro they matched me with was punctual, professional, and explained every step. My dryer is working more efficiently now. Highly recommend!`
      },
      {
        'name': 'Michael S.',
        'date': 'March 15, 2025',
        'review': `Thanks to HandyBy, I got connected with a local dryer vent pro ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who was upfront and honest. They cleaned the vent thoroughly and made sure everything was safe.`
      },
      {
        'name': 'Robert T.',
        'date': 'February 10, 2025',
        'review': 'Finding the right pro was effortless with HandyBy. The technician did a fantastic job cleaning my dryer vent and made sure the airflow was restored.'
      },
      {
        'name': 'Michael T.',
        'date': 'April 23, 2025',
        'review': `HandyBy matched me with a dryer vent specialist ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who discovered a serious blockage. They cleared it quickly and gave me helpful tips to prevent future issues.`
      },
      {
        'name': 'Steven T.',
        'date': 'March 08, 2025',
        'review': 'I used HandyBy to find a pro for dryer vent cleaning. The service was prompt, affordable, and my dryer now runs faster and safer. Highly recommend.'
      },
      {
        'name': 'James S.',
        'date': 'April 08, 2025',
        'review': 'The HandyBy platform connected me with a trustworthy dryer vent pro who explained everything clearly and didn’t try to upsell me. Great experience!'
      },
      {
        'name': 'Chloe P.',
        'date': 'March 25, 2025',
        'review': 'I had no idea who to call for dryer vent cleaning until I found HandyBy. The pro they recommended was thorough, honest, and left everything clean.'
      },
      {
        'name': 'Chloe J.',
        'date': 'March 28, 2025',
        'review': 'HandyBy helped me get in touch with a local pro who cleaned my dryer vent and fixed a minor airflow issue. Professional, affordable, and fast.'
      },
      {
        'name': 'John B.',
        'date': 'March 07, 2025',
        'review': 'I used HandyBy to request a dryer vent service and was impressed with how quickly they matched me with a pro. The work was excellent, and the price was fair.'
      },
      {
        'name': 'Jessica J.',
        'date': 'March 03, 2025',
        'review': 'HandyBy took the guesswork out of finding a good dryer vent cleaner. The pro was on time, friendly, and very knowledgeable. Couldn’t be happier.'
      },
      {
        'name': 'Emily D.',
        'date': 'April 15, 2025',
        'review': 'After struggling to find a reliable service, HandyBy matched me with a true professional. My dryer vent was cleaned thoroughly, and I received great maintenance tips.'
      },
      {
        'name': 'Daniel J.',
        'date': 'May 11, 2025',
        'review': 'Thanks to HandyBy, I didn’t have to waste time searching. The dryer vent pro they sent was efficient and explained everything. Highly recommend.'
      },
      {
        'name': 'Jessica P.',
        'date': 'May 05, 2025',
        'review': 'HandyBy made it simple to get dryer vent cleaning done right. The technician was polite, skilled, and completed the job quickly.'
      },
      {
        'name': 'Emily M.',
        'date': 'March 19, 2025',
        'review': 'I’m so glad I used HandyBy. They connected me with a local dryer vent expert who was honest, reasonably priced, and did a great job.'
      },
      {
        'name': 'Amanda R.',
        'date': 'March 25, 2025',
        'review': 'HandyBy matched me with a pro who was upfront about the work needed and didn’t try to upsell unnecessary services. Very satisfied.'
      },
      {
        'name': 'Amanda S.',
        'date': 'March 26, 2025',
        'review': 'The dryer vent pro HandyBy connected me with was fantastic. They were prompt, transparent with pricing, and left the area spotless.'
      },
      {
        'name': 'Amanda D.',
        'date': 'April 27, 2025',
        'review': 'Using HandyBy was a breeze. The pro they matched me with cleaned my dryer vent and even offered tips on fire prevention. Great service!'
      },
      {
        'name': 'Daniel B.',
        'date': 'February 16, 2025',
        'review': 'HandyBy helped me find a dryer vent technician who was both professional and friendly. They walked me through the whole process and delivered great results.'
      },
      {
        'name': 'Ashley R.',
        'date': 'March 09, 2025',
        'review': 'I trusted HandyBy to find a reliable dryer vent pro, and they delivered. The pro was thorough, polite, and did the job right the first time.'
      },
      {
        'name': 'Robert D.',
        'date': 'March 25, 2025',
        'review': 'I wasn’t sure where to start with dryer vent cleaning, but HandyBy made it easy. The pro they sent was excellent, transparent, and cleaned up after the job.'
      }],
      "Projects": [],
      "Services": [
        {
          "Title": "Dryer Vent Cleaning",
          "Description": "Thorough cleaning of dryer vents to prevent fire hazards and improve efficiency.",
          "Images": require(`../Images/airdutcinspection.avif`)
        },
        {
          "Title": "Dryer Vent Installation",
          "Description": "Professional installation of new dryer vents to ensure safety and efficiency.",
          "Images": require(`../Images/dryerrepair2.jpg`)

        },
        {
          "Title": "Dryer Vent Repair",
          "Description": "Expert repair services for damaged or malfunctioning dryer vents.",
          "Images": require(`../Images/dryerrepair.jpg`)
        },
        {
          "Title": "Dryer Vent Maintenance",
          "Description": "Regular maintenance services to keep dryer vents clean and functioning properly.",
          "Images": require(`../Images/dryer1.png.png`)
        },
        {
          "Title": "Dryer Vent Inspection",
          "Description": "Comprehensive inspections to identify potential issues and ensure optimal performance.",
          "Images": require(`../Images/dryerinspection.jpg`)
        },
        {
          "Title": "Dryer Vent Sealing",
          "Description": "Professional sealing services to prevent air leaks and improve energy efficiency.",
          "Images": require(`../Images/dryercleaned3.jpg`)
        },
        {
          "Title": "Dryer Vent Replacement",
          "Description": "Replacement of old or damaged dryer vents to ensure safety and efficiency.",
          "Images": require(`../Images/dryercleaned4.jpg`)
        },
      ],
      "ServicesByCategory": [
        {
          "category": "Dryer Vent Cleaning & Services",
          "services": [
            "ac and dryer vent cleaning",
            "dryer vent hose repair",
            "dryer vent repair",
            "dryer duct repair",
            "dryer vent repair service",
            "dryer vent installation service",
            "professional dryer vent installation",
            "dryer repair and vent cleaning",
            "dryer vent repair company",
            "dryer vent installation"
          ]
        },
        {
          "category": "Dryer Vent Repair & Installation",
          "services": [
            "dryer vent repair",
            "dryer duct repair",
            "dryer vent repair service",
            "dryer vent installation",
            "dryer vent hose repair",
            "dryer vent installation service",
            "dryer vent repair company",
            "dryer repair and vent cleaning",
            "dryer vent trap",
            "dryer vent replacement"
          ]
        },
        {
          "category": "Dryer Vent Inspection & Maintenance",
          "services": [
            "dryer vent inspection",
            "dryer lint cleaning service",
            "dryer trap cleaner",
            "dryer vent maintenance",
            "dryer cleaner",
            "dryer machine cleaning",
            "dryer vent cleaning system",
            "dryer cleaning service"
          ]
        },
        {
          "category": "Air Duct Cleaning",
          "services": [
            "indoor air duct cleaning",
            "air conditioner duct cleaning service",
            "duct cleaning",
            "commercial duct cleaning",
            "quality air duct cleaning",
            "vent cleaners for home",
            "duct cleaning services",
            "air duct cleaning experts",
            "air conditioning and heating duct cleaning",
            "clean duct vents",
            "central air cleaning service",
            "home ac cleaning service",
            "ac dust cleaning"
          ]
        },

      ],

      "faq": {
        data: {
          title: `Top 5 Dryer Vent Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            {
              title: "Why are these the Top 5 Dryer Vent Pros?",
              content: `These contractors were handpicked based on customer reviews, service quality, reliability, and response times in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}.`
            },
            {
              title: "Are these pros licensed and insured?",
              content: "Yes. All listed dryer vent professionals are fully licensed, insured, and verified to ensure safe and dependable service."
            },
            {
              title: "What services do these pros offer?",
              content: "They provide dryer vent cleaning, inspections, repairs, replacements, and safety checks for both residential and commercial properties."
            },
            {
              title: "How quickly can they schedule a service?",
              content: "Most of the pros offer same-day or next-day service depending on availability and location."
            },
            {
              title: "Is there a cost to choose from the Top 5?",
              content: "No. Viewing and selecting a contractor from the list is completely free and there’s no obligation to hire."
            },
            {
              title: "Can I request quotes from all three?",
              content: "Absolutely. You’re free to contact all three pros to compare pricing, timelines, and available services."
            }
          ]
        },
        styles: {
          bgColor: 'white',
          titleTextColor: '#282827',
          titleTextSize: '18px',
          rowTitleColor: '#282827',
          rowTitleTextSize: '18px',
          rowContentColor: '#242424',
          rowContentTextSize: '16px',
          // rowContentTextWeight: '600',
          rowContentPaddingTop: '10px',
          rowContentPaddingBottom: '0px',
          rowContentPaddingLeft: '5px',
          rowContentPaddingRight: '5px',
          arrowColor: "#282827",
          //transitionDuration: "1s",
          // timingFunc: "ease"
        },
        config: {
          // animate: true,
          // arrowIcon: "V",
          // tabFocus: true
          openOnload: 0,
        },
      }
    },
    // Chimney Category Info
    {
      "Category": "Chimney and Fireplace",
      "UrlCategory": "Chimney-Fireplace",
      "Image": require(`../Images/master-chimneygoogle5.jpg`),
      "Reviews": [{
        'name': 'Jessica S.',
        'date': 'March 03, 2025',
        'review': `HandyBy made it so easy to find a reliable chimney sweep ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. The pro they matched me with was punctual, professional, and explained every step. My fireplace looks great and works safely now. Highly recommend!`
      },
      {
        'name': 'Michael S.',
        'date': 'March 15, 2025',
        'review': `Thanks to HandyBy, I got connected with a local chimney expert ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who was upfront and honest. They inspected and cleaned my chimney thoroughly and even checked the cap for damage.`
      },
      {
        'name': 'Robert T.',
        'date': 'February 10, 2025',
        'review': 'Finding the right pro was effortless with HandyBy. The technician they sent did a fantastic job sweeping the chimney and was very respectful of my home.'
      },
      {
        'name': 'Michael T.',
        'date': 'April 23, 2025',
        'review': `HandyBy matched me with a chimney specialist ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who identified a creosote issue I wasn’t aware of. They handled it professionally and gave great safety tips.`
      },
      {
        'name': 'Steven T.',
        'date': 'March 08, 2025',
        'review': 'I used HandyBy to find a chimney sweep. The service was prompt, affordable, and I feel much safer using my fireplace now. Highly recommend.'
      },
      {
        'name': 'James S.',
        'date': 'April 08, 2025',
        'review': 'The HandyBy platform connected me with a trustworthy chimney tech who explained everything clearly and didn’t try to upsell me. Great experience!'
      },
      {
        'name': 'Chloe P.',
        'date': 'March 25, 2025',
        'review': 'I had no idea who to call for fireplace cleaning until I found HandyBy. The pro they recommended was thorough, honest, and left my fireplace spotless.'
      },
      {
        'name': 'Chloe J.',
        'date': 'March 28, 2025',
        'review': 'HandyBy helped me get in touch with a local pro who cleaned my chimney and fixed a minor crack in the crown. Professional, affordable, and fast.'
      },
      {
        'name': 'John B.',
        'date': 'March 07, 2025',
        'review': 'I used HandyBy to request a chimney service and was impressed with how quickly they matched me with a pro. The work was excellent, and the price was fair.'
      },
      {
        'name': 'Jessica J.',
        'date': 'March 03, 2025',
        'review': 'HandyBy took the guesswork out of finding a good chimney cleaner. The pro was on time, friendly, and very knowledgeable. Couldn’t be happier.'
      },
      {
        'name': 'Emily D.',
        'date': 'April 15, 2025',
        'review': 'After struggling to find a reliable chimney sweep, HandyBy matched me with a true professional. The cleaning was thorough, and I received helpful fireplace maintenance tips.'
      },
      {
        'name': 'Daniel J.',
        'date': 'May 11, 2025',
        'review': 'Thanks to HandyBy, I didn’t have to waste time searching. The chimney tech they sent was efficient and explained everything. Highly recommend.'
      },
      {
        'name': 'Jessica P.',
        'date': 'May 05, 2025',
        'review': 'HandyBy made it simple to get my fireplace cleaned and inspected. The technician was polite, skilled, and completed the job quickly.'
      },
      {
        'name': 'Emily M.',
        'date': 'March 19, 2025',
        'review': 'I’m so glad I used HandyBy. They connected me with a local chimney expert who was honest, reasonably priced, and did a great job.'
      },
      {
        'name': 'Amanda R.',
        'date': 'March 25, 2025',
        'review': 'HandyBy matched me with a pro who was upfront about the work needed and didn’t try to upsell unnecessary repairs. Very satisfied.'
      },
      {
        'name': 'Amanda S.',
        'date': 'March 26, 2025',
        'review': 'The chimney sweep HandyBy connected me with was fantastic. They were prompt, transparent with pricing, and left everything clean.'
      },
      {
        'name': 'Amanda D.',
        'date': 'April 27, 2025',
        'review': 'Using HandyBy was a breeze. The pro they matched me with cleaned my chimney and even inspected the fireplace damper for safety. Great service!'
      },
      {
        'name': 'Daniel B.',
        'date': 'February 16, 2025',
        'review': 'HandyBy helped me find a chimney technician who was both professional and friendly. They explained everything and gave great recommendations.'
      },
      {
        'name': 'Ashley R.',
        'date': 'March 09, 2025',
        'review': 'I trusted HandyBy to find a reliable chimney sweep, and they delivered. The pro was thorough, polite, and did the job right the first time.'
      },
      {
        'name': 'Robert D.',
        'date': 'March 25, 2025',
        'review': 'I wasn’t sure where to start with chimney maintenance, but HandyBy made it easy. The pro they sent was excellent, transparent, and cleaned up after the job.'
      }],
      "Projects": [],
      "Services": [
        {
          "Title": "Chimney Sweeping",
          "Description": "Thorough cleaning of the chimney to remove soot and debris.",
          "Images": require(`../Images/Chimney6.jpeg`)
        },
        {
          "Title": "Chimney Inspection",
          "Description": "Comprehensive inspection to identify potential issues.",
          "Images": require(`../Images/Chimney4.jpeg`)
        },
        {
          "Title": "Chimney Repair",
          "Description": "Expert repairs for any chimney damage or wear.",
          "Images": require(`../Images/master-chimneygoogle3.jpg`)
        },
        {
          "Title": "Chimney Cap Installation",
          "Description": "Installation of a chimney cap to prevent water damage and animal entry.",
          "Images": require(`../Images/master-chimneygoogle4.jpg`)
        },
        {
          "Title": "Liner Replacement",
          "Description": "Replacement of damaged or worn chimney liners to ensure safe operation.",
          "Images": require(`../Images/chimneyliner.jpg`)
        },
        {
          "Title": "Chimney Flashing Repair",
          "Description": "Repair of chimney flashing to prevent leaks and water damage.",
          "Images": require(`../Images/chimneyrepair.jpg`)
        },
        {
          "Title": "Crown Repair",
          "Description": "Repair of chimney crowns to prevent water damage and ensure proper drainage.",
          "Images": require(`../Images/rocket-69.jpg`)
        },
        {
          "Title": "Chimney Masonry",
          "Description": "Expert masonry services for chimney construction and repair.",
          "Images": require(`../Images/master-chimneygoogle5.jpg`)
        },
        {
          "Title": "Chimney Relining",
          "Description": "Professional relining services to restore chimney safety and efficiency.",
          "Images": require(`../Images/master-chimneygoogle1.jpg`)
        },
      ],
      "ServicesByCategory": [
        {
          "category": "Cleaning & Sweeping",
          "services": [
            "chimney cleaning",
            "fireplace cleaning",
            "chimney sweep",
            "fireplace sweep",
            "fireplace cleaning service",
            "fireplace chimney cleaning",
            "wood fireplace cleaning",
            "wood burning stove cleaning",
            "chimney cleaning services",
            "clean sweep chimney service"
          ]
        },
        {
          "category": "Inspection & Maintenance",
          "services": [
            "chimney inspection",
            "fireplace inspection",
            "chimney inspections",
            "fireplace and chimney inspection",
            "fireplace inspection and cleaning",
            "fireplace maintenance",
            "chimney maintenance",
            "fireplace maintenance service",
            "chimney liner maintenance",
            "chimney cleaning and repairs"
          ]
        },
        {
          "category": "Repair Services",
          "services": [
            "chimney repair",
            "fireplace repair",
            "fireplace cleaning and repair",
            "chimney crown repair",
            "chimney crack repair",
            "chimney cap repair",
            "chimney cap replacement",
            "chimney mortar repair",
            "chimney flashing repair",
            "chimney leak repair"
          ]
        },
        {
          "category": "Installation & Structural Work",
          "services": [
            "chimney liner installation",
            "chimney pipe installation",
            "chimney flue repair",
            "chimney cap installation",
            "chimney liner repair",
            "install chimney flue",
            "chimney flue tile repair",
            "chimney lining installation",
            "chimney relining",
            "chimney stove pipe installation"
          ]
        },
        {
          "category": "Cap, Crown & Cover Services",
          "services": [
            "chimney crown repair",
            "chimney crown replacement",
            "chimney cap installation",
            "chimney cap replacement",
            "chimney cap repair",
            "chimney chase cover replacement",
            "chimney cover repair",
            "chimney cover installation",
            "chimney crown crack repair",
            "chimney caps installation"
          ]
        },
        {
          "category": "Liner & Flue Components",
          "services": [
            "chimney liner installation",
            "chimney liner repair",
            "chimney liner maintenance",
            "chimney flue repair",
            "chimney flue crack repair",
            "chimney flue tile repair",
            "chimney flue liner installation",
            "chimney flue pipe repair",
            "install chimney flue",
            "chimney lining installation"
          ]
        },
        {
          "category": "Waterproofing & Leak Protection",
          "services": [
            "chimney leak repair",
            "chimney flashing repair",
            "chimney flashing installation",
            "chimney water leak repair",
            "chimney flashing replacement",
            "chimney flashing leak",
            "chimney roof repair",
            "chimney sealing",
            "chimney repair leaking",
            "roof leak repair in chimney"
          ]
        }
      ],
      "faq": {
        data: {
          title: `Top 5 Chimney & Fireplace Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            {
              title: "Why are these the Top 5 Chimney & Fireplace Pros?",
              content: `These contractors were handpicked based on customer reviews, service quality, reliability, and response times in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}.`
            },
            {
              title: "Are these pros licensed and insured?",
              content: "Yes. All listed chimney and fireplace professionals are fully licensed, insured, and verified to ensure safe and dependable service."
            },
            {
              title: "What services do these pros offer?",
              content: "They provide chimney sweeping, fireplace cleaning, inspections, repairs, relining, animal removal, and safety assessments for both residential and commercial properties."
            },
            {
              title: "How quickly can they schedule a service?",
              content: "Most of the pros offer same-day or next-day service depending on availability and location."
            },
            {
              title: "Is there a cost to choose from the Top 5?",
              content: "No. Viewing and selecting a contractor from the list is completely free and there’s no obligation to hire."
            },
            {
              title: "Can I request quotes from all three?",
              content: "Absolutely. You’re free to contact all three pros to compare pricing, timelines, and available services."
            }
          ]
        },
        styles: {
          bgColor: 'white',
          titleTextColor: '#282827',
          titleTextSize: '18px',
          rowTitleColor: '#282827',
          rowTitleTextSize: '18px',
          rowContentColor: '#242424',
          rowContentTextSize: '16px',
          // rowContentTextWeight: '600',
          rowContentPaddingTop: '10px',
          rowContentPaddingBottom: '0px',
          rowContentPaddingLeft: '5px',
          rowContentPaddingRight: '5px',
          arrowColor: "#282827",
          //transitionDuration: "1s",
          // timingFunc: "ease"
        },
        config: {
          // animate: true,
          // arrowIcon: "V",
          // tabFocus: true
          openOnload: 0,
        },
      }
    },
    // HVAC Category Info
    {
      "Category": "HVAC",
      "UrlCategory": "HVAC",
      "Image": require(`../Images/1-hvac.jpg`),
      "Reviews": [
        { 'name': 'Jessica S.', 'date': 'March 03, 2025', 'review': `HandyBy matched me with a great HVAC pro ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} — fast diagnosis, fair pricing, AC back up and running same day. Highly recommend!` },
        { 'name': 'Michael S.', 'date': 'April 11, 2025', 'review': `Called for furnace trouble. The technician HandyBy sent ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} found a cracked exchanger that saved my family from CO. Honest and thorough.` },
        { 'name': 'Robert T.', 'date': 'May 22, 2025', 'review': 'Got a complete heat pump install from a HandyBy pro. Professional crew, clean install, and the system runs whisper-quiet.' }
      ],
      "Projects": [],
      "Services": [
        { "Title": "AC Repair", "Description": "Same-day diagnostics and repair for central AC, heat pumps, and mini-splits.", "Images": require(`../Images/1-hvac.jpg`) },
        { "Title": "Furnace Installation", "Description": "High-efficiency gas, electric, and oil furnace installation with code-compliant venting.", "Images": require(`../Images/1-hvac.jpg`) },
        { "Title": "Heat Pump Service", "Description": "Air-source and ductless mini-split installation, repair, and maintenance.", "Images": require(`../Images/1-hvac.jpg`) },
        { "Title": "HVAC Maintenance", "Description": "Annual tune-ups that keep warranty in force and prevent breakdowns.", "Images": require(`../Images/1-hvac.jpg`) },
        { "Title": "Thermostat Installation", "Description": "Smart thermostat install — Nest, Ecobee, Honeywell — with C-wire upgrades.", "Images": require(`../Images/1-hvac.jpg`) }
      ],
      "ServicesByCategory": [
        { "category": "Cooling", "services": ["ac repair", "ac installation", "central air install", "mini-split installation", "ductless ac repair", "ac coil cleaning", "refrigerant recharge", "compressor replacement", "ac tune-up", "ac maintenance"] },
        { "category": "Heating", "services": ["furnace repair", "furnace installation", "heat pump installation", "heat pump repair", "boiler repair", "boiler installation", "radiant heat repair", "thermostat replacement", "gas line repair", "carbon monoxide testing"] },
        { "category": "Maintenance & Tune-Up", "services": ["hvac tune-up", "annual maintenance", "filter replacement", "duct cleaning", "system inspection", "energy efficiency audit", "warranty service", "smart thermostat install", "indoor air quality", "humidity control"] }
      ],
      "faq": {
        data: {
          title: `Top 5 HVAC Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            { title: "Why are these the Top 5 HVAC Pros?", content: `Handpicked based on customer reviews, response time, and licensing in ${CitiesData && CitiesData.Full ? CitiesData.Full : "your area"}.` },
            { title: "Are these pros licensed and insured?", content: "Yes — all HVAC pros are licensed, bonded, and insured for both residential and light commercial work." },
            { title: "What HVAC services do they offer?", content: "Central AC, heat pump, furnace, mini-split, thermostat, ductwork, and full maintenance contracts." },
            { title: "How quickly can they show up?", content: "Most offer same-day or next-day service. Many run 24/7 emergency lines during peak season." },
            { title: "Is there a cost to choose from the Top 5?", content: "No — viewing and contacting pros from HandyBy is always free." }
          ]
        },
        styles: { bgColor: 'white', titleTextColor: '#282827', titleTextSize: '18px', rowTitleColor: '#282827', rowTitleTextSize: '18px', rowContentColor: '#242424', rowContentTextSize: '16px', rowContentPaddingTop: '10px', rowContentPaddingBottom: '0px', rowContentPaddingLeft: '5px', rowContentPaddingRight: '5px', arrowColor: "#282827" },
        config: { openOnload: 0 }
      }
    },
    // Roofing Category Info
    {
      "Category": "Roofing",
      "UrlCategory": "Roofing",
      "Image": require(`../Images/1-roofing.jpg`),
      "Reviews": [
        { 'name': 'Jessica S.', 'date': 'March 03, 2025', 'review': `HandyBy connected me with a roofer ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} after a bad storm. Fast tarp service, clean repair, and great with my insurance adjuster.` },
        { 'name': 'Michael S.', 'date': 'April 11, 2025', 'review': `Got a full roof replacement from a HandyBy pro ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Crew was on time every day, cleanup was perfect, and they pulled the permit for me.` },
        { 'name': 'Robert T.', 'date': 'May 22, 2025', 'review': 'Needed a small roof leak fixed. The HandyBy roofer found it in 10 minutes and had it sealed in an hour. Honest and fast.' }
      ],
      "Projects": [],
      "Services": [
        { "Title": "Roof Repair", "Description": "Fast leak repair, missing shingle replacement, and storm damage fixes.", "Images": require(`../Images/1-roofing.jpg`) },
        { "Title": "Roof Replacement", "Description": "Full roof replacement — asphalt shingle, metal, and specialty materials.", "Images": require(`../Images/1-roofing.jpg`) },
        { "Title": "Roof Inspection", "Description": "Professional inspections for home buyers, sellers, and insurance claims.", "Images": require(`../Images/1-roofing.jpg`) },
        { "Title": "Gutter Installation", "Description": "Seamless aluminum gutters properly sized for your roof and rainfall.", "Images": require(`../Images/1-roofing.jpg`) },
        { "Title": "Storm Damage Repair", "Description": "Emergency tarp service, full damage documentation, and insurance coordination.", "Images": require(`../Images/1-roofing.jpg`) }
      ],
      "ServicesByCategory": [
        { "category": "Repair & Leak", "services": ["roof repair", "roof leak repair", "shingle replacement", "flashing repair", "valley repair", "pipe boot replacement", "roof patch", "emergency roof tarp", "wind damage repair", "hail damage repair"] },
        { "category": "Replacement & New Install", "services": ["roof replacement", "asphalt shingle install", "metal roof install", "tile roof install", "flat roof install", "tpo roofing", "epdm roofing", "roof tear-off", "new construction roofing", "reroofing"] },
        { "category": "Gutter & Drainage", "services": ["gutter installation", "gutter repair", "gutter cleaning", "gutter guard install", "downspout install", "downspout repair", "rain barrel install", "ice dam removal", "leaf guard installation", "soffit and fascia repair"] }
      ],
      "faq": {
        data: {
          title: `Top 5 Roofing Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            { title: "Why are these the Top 5 Roofing Pros?", content: `Handpicked based on customer reviews, response time, and licensing in ${CitiesData && CitiesData.Full ? CitiesData.Full : "your area"}.` },
            { title: "Are these pros licensed and insured?", content: "Yes — all roofers are licensed, bonded, and insured. We verify before listing." },
            { title: "What roofing services do they offer?", content: "Roof repair, full replacement, inspection, gutters, storm damage, and skylight install." },
            { title: "Will they handle the insurance claim?", content: "Yes — most of our pros work directly with insurance adjusters for storm and hail claims." },
            { title: "Is there a cost to choose from the Top 5?", content: "No — viewing and contacting pros from HandyBy is always free." }
          ]
        },
        styles: { bgColor: 'white', titleTextColor: '#282827', titleTextSize: '18px', rowTitleColor: '#282827', rowTitleTextSize: '18px', rowContentColor: '#242424', rowContentTextSize: '16px', rowContentPaddingTop: '10px', rowContentPaddingBottom: '0px', rowContentPaddingLeft: '5px', rowContentPaddingRight: '5px', arrowColor: "#282827" },
        config: { openOnload: 0 }
      }
    },
    // Garage Door Category Info
    {
      "Category": "Garage Door",
      "UrlCategory": "Garage-Door",
      "Image": require(`../Images/1-garage.jpg`),
      "Reviews": [
        { 'name': 'Jessica S.', 'date': 'March 03, 2025', 'review': `HandyBy got me a garage door tech same day ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Broken spring fixed in under an hour. Saved my morning.` },
        { 'name': 'Michael S.', 'date': 'April 11, 2025', 'review': `New garage door install through HandyBy ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Clean work, smart opener included, and they hauled the old door away.` },
        { 'name': 'Robert T.', 'date': 'May 22, 2025', 'review': 'Opener stopped working — HandyBy pro diagnosed a bad logic board, replaced it, and synced all my remotes. Fast and pro.' }
      ],
      "Projects": [],
      "Services": [
        { "Title": "Garage Door Repair", "Description": "Spring, cable, panel, and roller repair — same-day service most days.", "Images": require(`../Images/1-garage.jpg`) },
        { "Title": "Garage Door Installation", "Description": "New door install — steel, wood, or insulated — with full warranty.", "Images": require(`../Images/1-garage.jpg`) },
        { "Title": "Garage Door Opener", "Description": "Opener install, repair, and smart-WiFi opener upgrades.", "Images": require(`../Images/1-garage.jpg`) },
        { "Title": "Spring Replacement", "Description": "Torsion and extension spring replacement — the #1 garage door repair.", "Images": require(`../Images/1-garage.jpg`) },
        { "Title": "Off-Track Door Repair", "Description": "Re-railing a door that's jumped the track — fast and safe.", "Images": require(`../Images/1-garage.jpg`) }
      ],
      "ServicesByCategory": [
        { "category": "Repair", "services": ["garage door repair", "spring replacement", "cable replacement", "panel repair", "roller replacement", "off-track repair", "weather seal replacement", "remote programming", "lock repair", "alignment adjustment"] },
        { "category": "Installation", "services": ["garage door installation", "garage door opener install", "smart opener install", "new garage door", "wood garage door", "insulated garage door", "carriage style door", "side-mount opener", "battery backup install", "wifi opener install"] },
        { "category": "Maintenance & Safety", "services": ["garage door tune-up", "annual maintenance", "safety sensor calibration", "balance check", "spring lifecycle test", "opener belt service", "force adjustment", "auto-reverse test", "lubrication service", "weather stripping replacement"] }
      ],
      "faq": {
        data: {
          title: `Top 5 Garage Door Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            { title: "Why are these the Top 5 Garage Door Pros?", content: `Handpicked based on customer reviews, response time, and licensing in ${CitiesData && CitiesData.Full ? CitiesData.Full : "your area"}.` },
            { title: "Do they fix broken springs same day?", content: "Yes — broken springs are the most common emergency. Most pros stock common sizes." },
            { title: "Will they replace a smart opener?", content: "Yes — they install all major smart openers including LiftMaster, Chamberlain, and Genie." },
            { title: "Are these pros licensed and insured?", content: "Yes. All garage door pros are licensed, bonded, and insured." },
            { title: "Is there a cost to choose from the Top 5?", content: "No — viewing and contacting pros from HandyBy is always free." }
          ]
        },
        styles: { bgColor: 'white', titleTextColor: '#282827', titleTextSize: '18px', rowTitleColor: '#282827', rowTitleTextSize: '18px', rowContentColor: '#242424', rowContentTextSize: '16px', rowContentPaddingTop: '10px', rowContentPaddingBottom: '0px', rowContentPaddingLeft: '5px', rowContentPaddingRight: '5px', arrowColor: "#282827" },
        config: { openOnload: 0 }
      }
    },
    // Locksmith Category Info
    {
      "Category": "Locksmith",
      "UrlCategory": "Locksmith",
      "Image": require(`../Images/1-locksmith.jpg`),
      "Reviews": [
        { 'name': 'Jessica S.', 'date': 'March 03, 2025', 'review': `Locked out at midnight — HandyBy connected me with a 24/7 locksmith ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"} who was there in 30 minutes. Lifesaver.` },
        { 'name': 'Michael S.', 'date': 'April 11, 2025', 'review': `Had all the locks rekeyed after closing on a new house ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Fair price, smart-lock upgrade included.` },
        { 'name': 'Robert T.', 'date': 'May 22, 2025', 'review': 'Car key replacement through HandyBy. Pro came to the parking lot and cut and programmed the key on the spot.' }
      ],
      "Projects": [],
      "Services": [
        { "Title": "Lockout Service", "Description": "24/7 emergency lockout — home, car, business.", "Images": require(`../Images/1-locksmith.jpg`) },
        { "Title": "Rekey Service", "Description": "Rekey every lock in your home for a fraction of replacement cost.", "Images": require(`../Images/1-locksmith.jpg`) },
        { "Title": "Lock Installation", "Description": "New deadbolt, smart lock, or high-security lock installation.", "Images": require(`../Images/1-locksmith.jpg`) },
        { "Title": "Car Key Replacement", "Description": "Lost car key cut and programmed on-site — most makes and models.", "Images": require(`../Images/1-locksmith.jpg`) },
        { "Title": "Safe Opening", "Description": "Open jammed, locked, or forgotten-combination safes without damage.", "Images": require(`../Images/1-locksmith.jpg`) }
      ],
      "ServicesByCategory": [
        { "category": "Emergency", "services": ["lockout service", "24 hour locksmith", "emergency lockout", "house lockout", "car lockout", "business lockout", "broken key extraction", "lost key replacement", "weekend locksmith", "late night locksmith"] },
        { "category": "Residential", "services": ["rekey locks", "lock installation", "deadbolt installation", "smart lock install", "high security lock install", "patio door lock", "front door lock", "interior door lock", "mailbox lock", "garage entry lock"] },
        { "category": "Automotive & Commercial", "services": ["car key replacement", "transponder key programming", "ignition repair", "key fob replacement", "commercial lock change", "master key system", "panic bar install", "access control install", "safe opening", "safe combination change"] }
      ],
      "faq": {
        data: {
          title: `Top 5 Locksmiths in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            { title: "Why are these the Top 5 Locksmiths?", content: `Handpicked based on customer reviews, response time, and licensing in ${CitiesData && CitiesData.Full ? CitiesData.Full : "your area"}.` },
            { title: "Do they offer 24-hour emergency service?", content: "Yes — most listed locksmiths run a 24/7 emergency line for lockouts." },
            { title: "Will they rekey vs. replace locks?", content: "Both. Rekey is cheaper and works when locks are good quality. They'll recommend whichever fits your situation." },
            { title: "Are these locksmiths licensed and bonded?", content: "Yes. All locksmiths are vetted, licensed (where required by state), and insured." },
            { title: "Is there a cost to choose from the Top 5?", content: "No — viewing and contacting pros from HandyBy is always free." }
          ]
        },
        styles: { bgColor: 'white', titleTextColor: '#282827', titleTextSize: '18px', rowTitleColor: '#282827', rowTitleTextSize: '18px', rowContentColor: '#242424', rowContentTextSize: '16px', rowContentPaddingTop: '10px', rowContentPaddingBottom: '0px', rowContentPaddingLeft: '5px', rowContentPaddingRight: '5px', arrowColor: "#282827" },
        config: { openOnload: 0 }
      }
    },
    // Insulation Category Info
    {
      "Category": "Insulation",
      "UrlCategory": "Insulation",
      "Image": require(`../Images/1-insulation.jpg`),
      "Reviews": [
        { 'name': 'Jessica S.', 'date': 'March 03, 2025', 'review': `Attic insulation upgrade through HandyBy ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Heating bill dropped by 25% the first month. Worth every dollar.` },
        { 'name': 'Michael S.', 'date': 'April 11, 2025', 'review': `Got blown-in insulation done ${CitiesData && CitiesData.City ? "in " + CitiesData.City : "in my area"}. Crew was clean, fast, and explained the R-value difference clearly.` },
        { 'name': 'Robert T.', 'date': 'May 22, 2025', 'review': 'Spray foam in the basement — house is noticeably warmer and the cold floor problem is gone. Pro work.' }
      ],
      "Projects": [],
      "Services": [
        { "Title": "Attic Insulation", "Description": "Blown-in cellulose or fiberglass to bring attic R-value up to code.", "Images": require(`../Images/1-insulation.jpg`) },
        { "Title": "Spray Foam Insulation", "Description": "Open-cell and closed-cell spray foam for walls, rim joists, and tight spaces.", "Images": require(`../Images/1-insulation.jpg`) },
        { "Title": "Wall Insulation", "Description": "Dense-pack insulation injected into existing walls — no demo.", "Images": require(`../Images/1-insulation.jpg`) },
        { "Title": "Crawlspace Insulation", "Description": "Encapsulation and insulation for crawlspaces — stops cold floors and moisture issues.", "Images": require(`../Images/1-insulation.jpg`) },
        { "Title": "Insulation Removal", "Description": "Remove old, damaged, or rodent-contaminated insulation before new install.", "Images": require(`../Images/1-insulation.jpg`) }
      ],
      "ServicesByCategory": [
        { "category": "Residential Insulation", "services": ["attic insulation", "wall insulation", "basement insulation", "crawlspace insulation", "garage insulation", "soundproofing insulation", "rim joist insulation", "knee wall insulation", "cathedral ceiling insulation", "pipe insulation"] },
        { "category": "Material Types", "services": ["blown-in cellulose", "blown-in fiberglass", "spray foam open cell", "spray foam closed cell", "batt insulation", "rigid foam board", "mineral wool insulation", "radiant barrier install", "rockwool insulation", "denim insulation"] },
        { "category": "Removal & Remediation", "services": ["insulation removal", "rodent contamination cleanup", "mold remediation insulation", "water damage insulation", "asbestos insulation removal", "vermiculite removal", "fire damage insulation", "old insulation disposal", "attic deep clean", "duct insulation removal"] }
      ],
      "faq": {
        data: {
          title: `Top 5 Insulation Pros in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}`,
          rows: [
            { title: "Why are these the Top 5 Insulation Pros?", content: `Handpicked based on customer reviews, response time, and licensing in ${CitiesData && CitiesData.Full ? CitiesData.Full : "your area"}.` },
            { title: "Are these pros licensed and insured?", content: "Yes — all insulation contractors are licensed, bonded, and insured." },
            { title: "What insulation materials do they install?", content: "Blown-in cellulose and fiberglass, spray foam (open and closed cell), batt, and rigid board." },
            { title: "Will they remove old insulation first?", content: "Yes. Most jobs include hauling out old material when needed, especially if rodent-contaminated." },
            { title: "Is there a cost to choose from the Top 5?", content: "No — viewing and contacting pros from HandyBy is always free." }
          ]
        },
        styles: { bgColor: 'white', titleTextColor: '#282827', titleTextSize: '18px', rowTitleColor: '#282827', rowTitleTextSize: '18px', rowContentColor: '#242424', rowContentTextSize: '16px', rowContentPaddingTop: '10px', rowContentPaddingBottom: '0px', rowContentPaddingLeft: '5px', rowContentPaddingRight: '5px', arrowColor: "#282827" },
        config: { openOnload: 0 }
      }
    }

  ]);



  useEffect(() => {
    (async () => {

      // Set User Proojects List in LocalSstorage
      if (localStorage.getItem("Project") && JSON.parse(localStorage.getItem("Project")).length) {
        setProjectList(ProjectList)
        localStorage.setItem("Project", JSON.stringify(ProjectList))
      } else {
        localStorage.setItem("Project", JSON.stringify(ProjectList))
      }

      // Google Get User Location
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }

      }

      // Microsoft Get User Location
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }

      }

      // Get user corrent ZIP Code
      const getLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => { reverseGeocode(position.coords.latitude, position.coords.longitude); });
        }
      };
      const reverseGeocode = async (latitude, longitude) => {
        if (localStorage.getItem("ZipCode") && localStorage.getItem("ZipCode").length) {
          try {
            localStorage.setItem("ZipCode", parseInt(ZipCode))
          } catch (err) { }
        } else {
          console.log("not exist");
          try {
            const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0`);
            localStorage.setItem("ZipCode", parseInt(response.data.results[0].address_components.find(component => component.types.includes("postal_code"))?.long_name))
            setZipCode(response.data.results[0].address_components.find(component => component.types.includes("postal_code"))?.long_name)
          } catch (err) { }
        }
      };
      getLocation();

      // Get User Info Session
      const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/handyby-users?q={"UserID":"${JSON.parse(localStorage.getItem("UserSessionn")).UserID}"}&h={"$fields": {"UserEmail": 1, "FirstName": 1, "LastName": 1, "PhoneNumber": 1, "UserEmail": 1, "UserDateCreated": 1, "LastLoginUserDate": 1, "UserIP": 1,"UserID": 1,"UserAgent": 1,"UserProfilePicture": 1,"FirstProject": 1} }`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'apikey': '6714a668e2b4472fa2c2d036'

        }
      });
      const data1 = await res1.json()
      if (data1) {
        localStorage.setItem("UserSessionn", JSON.stringify({
          FirstName: data1[0].FirstName,
          LastName: data1[0].LastName,
          PhoneNumber: data1[0].PhoneNumber,
          UserEmail: data1[0].Email,
          UserDateCreated: data1[0].UserDateCreated,
          LastLoginUserDate: data1[0].LastLoginUserDate,
          UserIP: data1[0].UserIP,
          UserID: data1[0].UserID,
          UserAgent: data1[0].UserAgent,
          FirstProject: data1[0].FirstProject,
          UserProfilePicture: data1[0].UserProfilePicture,
        }))
      }
      setUserSession(data1[0])
      setUpdateAppSub(a => !a)
    })();

    //   
  }, [UpdateApp]);
  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>
      {/* Menu */}
      {showMenu ? <Menu setUserSession={setUserSession} UserSession={UserSession} showsetNotification={showsetNotification} showsetNotificationType={showsetNotificationType} ServicesData={ServicesData} setShowMenu={setShowMenu} setUpdateApp={setUpdateApp} /> : null}
      {/* Header */}
      {location.pathname.match("/request-service") || location.pathname.match("/login") || location.pathname.match("/sign-up") ? null : <Header setShowAllCompanies={setShowAllCompanies} ZipCode={ZipCode} UserSession={UserSession} showMenu={showMenu} setShowMenu={setShowMenu} />}
      {/* Main App */}
      <Main
        Companies={Companies}
        CategoryInfo={CategoryInfo}
        ShowAllCompanies={ShowAllCompanies}
        setShowAllCompanies={setShowAllCompanies}
        CitiesData={CitiesData}
        UserSession={UserSession}
        ZipCode={ZipCode}
        setZipCode={setZipCode}
        ServicesData={ServicesData}
        setUpdateApp={setUpdateApp}
        ProjectList={ProjectList}
        setProjectList={setProjectList}
        WebSitePages={WebSitePages}
        showsetNotification={showsetNotification}
        showsetNotificationType={showsetNotificationType}
      />
      {/* Footer */}
      {location.pathname.match("/request-service") || location.pathname.match("/login") || location.pathname.match("/sign-up") || location.pathname.match("/account") || url.searchParams.get('spg') ? null : <Footer CategoryInfo={CategoryInfo} Companies={Companies} WebSitePages={WebSitePages} />}
      {/* Notification */}
      {showNotification ? <Notification showNotificationType={showNotificationType} showsetNotification={showsetNotification} /> : null}

    </div>
  );
}

export default App;
